import BankVoucherFormPage from "./BankVoucherFormPage";

export default function ContraVoucherPage() {
  return <BankVoucherFormPage voucherType="CONTRA" title="Contra Voucher" subtitle="Transfers between the society's own Cash and Bank Accounts." />;
}
